import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ContractorUserData } from '../user';

const portalUserApiUrl = `${environment.portalApiUrl}/contractor-user-data`;

@Injectable({ providedIn: 'root' })
export class ContractorUserApiService {
  constructor(private http: HttpClient) {}

  fetchContractorUserData(): Promise<ContractorUserData | null> {
    return firstValueFrom(
      this.http
        .get<ContractorUserData>(`${portalUserApiUrl}`)
        .pipe(catchError(() => of(null))),
    );
  }
}
